export default __webpack_public_path__ + "static/media/Arrow Right dark.11407552.svg";